// Format a number using the pattern inferred from an existing formatted price
export const formatLikePrice = (
  value: number,
  formattedReference: string,
): string => {
  // Extract prefix (everything before first digit)
  const prefixMatch = formattedReference.match(/^[^\d]*/);
  const prefix = prefixMatch ? prefixMatch[0] : "";

  // Extract suffix (everything after last digit)
  const suffixMatch = formattedReference.match(/[^\d]*$/);
  const suffix = suffixMatch ? suffixMatch[0] : "";

  // Check for decimals in reference
  const decimalMatch = formattedReference.match(/(\d)([.,])(\d+)(?=[^\d]*$)/);
  const hasDecimals = !!decimalMatch;
  const decimalSeparator = decimalMatch ? decimalMatch[2] : ".";
  const decimalPlaces = decimalMatch ? decimalMatch[3].length : 0;

  // Detect thousands separator (space, comma, period, or apostrophe between digit groups)
  const thousandsMatch = formattedReference.match(/\d([ .,'])(?=\d{3})/);
  const thousandsSeparator = thousandsMatch ? thousandsMatch[1] : " ";

  // Format the integer part with thousands separator
  const integerPart = Math.floor(value);
  const formattedInteger = integerPart
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);

  // Format decimal part if needed
  let formattedDecimal = "";
  if (hasDecimals) {
    const decimalPart = Math.round(
      (value - integerPart) * Math.pow(10, decimalPlaces),
    );
    formattedDecimal =
      decimalSeparator + decimalPart.toString().padStart(decimalPlaces, "0");
  }

  return `${prefix}${formattedInteger}${formattedDecimal}${suffix}`;
};
